export const generateOptions = (options: string[]) =>
  options.map((opt: string) => ({
    value: opt,
    label: opt,
  }))
